import apiClient from './client';
import { Faq } from '@/types';

export interface FaqListResponse {
  data: Faq[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
}

export const faqApi = {
  getAll: async (params: { page?: number; limit?: number } = {}): Promise<FaqListResponse> => {
    const response = await apiClient.get('/api/faq', { params: { ...params, active: false } });
    return response.data;
  },

  create: async (data: Partial<Faq>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/faq', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Faq>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/faq/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/faq/${id}`);
    return response.data;
  },
};
